<template>
  <ul class="winners-2021-place-winners-card-prize-list">
    <li
      v-for="(prize, index) in list"
      :key="index"
      class="winners-2021-place-winners-card-prize-list__li"
    >
      <Winners2021PlaceWinnersCardPrize :prize="prize" />
    </li>
  </ul>
</template>

<script>
import Winners2021PlaceWinnersCardPrize from "./Winners2021PlaceWinnersCardPrize";

export default {
  name: "Winners2021PlaceWinnersCardPrizeListvue",
  components: {
    Winners2021PlaceWinnersCardPrize
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
.winners-2021-place-winners-card-prize-list {
  list-style: none;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -5px -10px;

  &__li {
    padding: 5px 10px;
  }
}
</style>
